import React, { useState } from "react";
import {
  Card,
  Typography,
  CardActionArea,
  Box,
  Collapse,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import OPDReports from "../../HospitalPages/OPD/OPDReports/OPDReports";
import RegisterOPDVisit from "../../HospitalPages/OPD/RegisterOPDVisit";
import AppointmentScheduling from "../../HospitalPages/OPD/AppointmentScheduling";
import DoctorwiseOPDList from "../../HospitalPages/OPD/DoctorwiseOPDList";
import ConsultationNotesPrescriptions from "../../HospitalPages/OPD/ConsultationNotesPrescriptions";
import OPDBilling from "../../HospitalPages/OPD/OPDBilling";
import DashboardCards from "../HospitalDashBoardCards";
import { decrypt } from "../../components/cryptoUtil";
 import { includeCardForRoles, ROLES } from "../componenet/heading";

const OpdDashBoard = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));


const tokenData = localStorage.getItem("tokenData");
  const decryptedData = tokenData ? JSON.parse(decrypt(tokenData)) : {};
  const userName = decryptedData.userfullname || "";
const userRole = decryptedData.userrole || "";



const cardRoles = {
  "OPD Patient Registration": [ROLES.RECEPTIONIST], // only userRole 101 can see
  "Appointment Scheduling": [ROLES.RECEPTIONIST],   // only userRole 102 can see
  "Doctor-wise OPD List": [ROLES.RECEPTIONIST],
  "Consultation Notes / Prescriptions": [ROLES.STAFF],
  "OPD Billing": [ROLES.ACCOUNTSECTION],
  "OPD Reports": [ROLES.DOCTOR,ROLES.RECEPTIONIST],
};



  const cards = [
     ...includeCardForRoles(cardRoles["OPD Patient Registration"], userRole,{
      title: "OPD Patient Registration",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🏥</span> : null,
      component: <RegisterOPDVisit />,category: "👨‍⚕️ OPD Data Managament",
    }),
    ...includeCardForRoles(cardRoles["Appointment Scheduling"], userRole,{
      title: "Appointment Scheduling",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🛌</span> : null,
      component: <AppointmentScheduling />,category: "👨‍⚕️ OPD Data Managament",
    }),
   
    ...includeCardForRoles(cardRoles["Doctor-wise OPD List"], userRole,{
      title: "Doctor-wise OPD List",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>✔️</span> : null,
      component: <DoctorwiseOPDList />,category: "👨‍⚕️ OPD Data Managament",
    }),
    ...includeCardForRoles(cardRoles["Consultation Notes / Prescriptions"], userRole,{
      title: "Consultation Notes / Prescriptions",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <ConsultationNotesPrescriptions />,category: "👨‍⚕️ OPD Data Managament",
    }),

    ...includeCardForRoles(cardRoles["OPD Billing"], userRole,{
      title: "OPD Billing",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <OPDBilling />,category: "👨‍⚕️ OPD Data Managament",
    }),
    ...includeCardForRoles(cardRoles["OPD Reports"], userRole,{
      title: "OPD Reports",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <OPDReports />,category: "👨‍⚕️ OPD Data Managament",
    }),
  ];


  
     return (
      <DashboardCards
        cards={cards}
        menulabel={1}
        welcomeMessage={
          
          <Typography variant="h5" align="center" gutterBottom>
            {/*  */}
            👨‍⚕️ OPD Data Managament
          </Typography>
        }
      />
    );
  };


export default OpdDashBoard;
